import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTruckType } from '@/features/truck-types/api'

import { truckTypeParamsSchema } from '../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/truck-types/$truckTypeId'
)({
  parseParams: (params) => parse(truckTypeParamsSchema, params),
  loader: async ({ params: { tenantKey, truckTypeId }, context: { auth } }) => {
    const truckType = await fetchTruckType({ tenantKey, truckTypeId })
    return {
      truckType,
      authUser: auth.user
    }
  },
  meta: ({ loaderData }) => [{ title: loaderData.truckType.name }]
})
